import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageBloodgroupChild from "./ManageBloodgroupChild";

const ManageBloodgroup = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageBloodgroupChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageBloodgroup;
